// Shared mapping of channel slugs to their Giblet images
import ispaiGiblet from "@/assets/giblets/ispai-giblet.png";
import curtGiblet from "@/assets/giblets/curt-giblet.png";
import oilGasGiblet from "@/assets/giblets/oil-gas-giblet.png";
import usaGiblet from "@/assets/giblets/usa-giblet.png";
import utthungaGiblet from "@/assets/giblets/utthunga-giblet.png";
import defaultGiblet from "@/assets/giblets/default-giblet.png";

export const channelGibletMap: Record<string, string> = {
  'ispai': ispaiGiblet,
  'curt': curtGiblet,
  'oil-gas': oilGasGiblet,
  'oil-and-gas': oilGasGiblet,
  'usa-gsa': usaGiblet,
  'usa': usaGiblet,
  'us-federal-government': usaGiblet,
  'utthunga': utthungaGiblet,
  'education': defaultGiblet,
};

export const getChannelGiblet = (slug: string): string => {
  return channelGibletMap[slug.toLowerCase()] || defaultGiblet;
};

export { defaultGiblet };
